import { cn, pluralize } from '@nesso/ui/lib/utils';
import { TableCell, TableRow } from '@nesso/ui/primitives/table';

import type { PracticeMemberUsageSummary } from '@/entities/reporting';

import {
    GROUP_DIVIDER,
    NAME_COLUMN_SCROLL_SHADOW,
    NAME_COLUMN_WIDTH,
    NOTE_COUNT_CELL,
    SCROLLABLE_COLUMN_WIDTH,
} from './reporting-page-practice-member-usage-table-columns';

// This row holds one line where body rows hold two (name over email), so a content-sized height
// would break row alignment.
const ROW_HEIGHT = 'h-13';
const SUMMARY_CELL = 'sticky top-10 z-20 bg-card font-bold';
const SUMMARY_CORNER_CELL = 'sticky left-0 top-10 z-30 bg-card font-bold';

type Props = {
    summary: PracticeMemberUsageSummary;
    isScrolled: boolean;
};

// Rendered as `subHeaderRow` inside `<TableHeader>`: never virtualized, pinned directly beneath
// the column headers at top-10 (40px).
export function ReportingPagePracticeMemberUsageTableSummaryRow({ summary, isScrolled }: Props) {
    return (
        <TableRow className={cn('hover:bg-transparent', ROW_HEIGHT)}>
            <TableCell
                className={cn(
                    SUMMARY_CORNER_CELL,
                    NAME_COLUMN_WIDTH,
                    isScrolled && NAME_COLUMN_SCROLL_SHADOW,
                )}
            >
                {pluralize(summary.practiceMemberCount, 'Practice Member')}
            </TableCell>
            {/* Last log in / Last session carry no summary, so they stay blank. */}
            <TableCell className={cn(SUMMARY_CELL, SCROLLABLE_COLUMN_WIDTH)} />
            <TableCell className={cn(SUMMARY_CELL, GROUP_DIVIDER, SCROLLABLE_COLUMN_WIDTH)} />
            <TableCell className={cn(SUMMARY_CELL, NOTE_COUNT_CELL, SCROLLABLE_COLUMN_WIDTH)}>
                {summary.allNotes}
            </TableCell>
            <TableCell className={cn(SUMMARY_CELL, NOTE_COUNT_CELL, SCROLLABLE_COLUMN_WIDTH)}>
                {summary.last30Days}
            </TableCell>
            <TableCell
                className={cn(
                    SUMMARY_CELL,
                    NOTE_COUNT_CELL,
                    GROUP_DIVIDER,
                    SCROLLABLE_COLUMN_WIDTH,
                )}
            >
                {summary.last7Days}
            </TableCell>
            <TableCell className={cn(SUMMARY_CELL, SCROLLABLE_COLUMN_WIDTH)} />
        </TableRow>
    );
}
